// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2ePKw","dragIcon":"Choice_dragIcon__1aqb3","left":"Choice_left__3No8s","input":"Choice_input__2aIzu"};